import { Devices } from "./devices";


export default {
    'devices': new Devices().getModule(),
}